import { usePartyUi } from '@gmp/shared-ui';
import { Lobby } from './Lobby';
import { GameShell } from './GameShell';
import { FinalResults } from './Results';
import { usePartyState } from '../App';
import { FeedTicker } from '../app/Feed';

export function PartyScreen() {
  const { room } = usePartyUi();
  const { game } = usePartyState();
  const screen = room.stage === 'IN_GAME' && game ? <GameShell game={game} /> : room.stage === 'FINAL_RESULTS' ? <FinalResults /> : <Lobby />;
  return (
    <>
      {screen}
      <FeedTicker />
    </>
  );
}
